import api from '../../utils/api';

export const removeUnit = (id: number) =>
  api.delete({
    url: `/unit/${id}`,
  });
